import React from "react"

const PageNotSupported: React.FC = () => {
    return (
        <div className="layout-404">
            <h1>410</h1>
            <h2>Страница больше не поддерживается</h2>
            <p>
                Этот раздел больше недоступен.
                <br />
                Функциональность страницы была отключена.
            </p>
        </div>
    )
}

export default PageNotSupported